import { overdueChambers } from '../attention';
import type { ChamberStatus, SystemPulse } from '../../../types/dashboard';

interface Props {
  pulse: SystemPulse;
  /** Момент, коли дашборд востаннє підтягнув дані з бази. */
  updatedAt: number;
  chambers: ChamberStatus[];
}

const STAMP_FMT: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export function StatusBar({ pulse, updatedAt, chambers }: Props) {
  const stamp = new Date(updatedAt).toLocaleString('uk-UA', STAMP_FMT).replace(',', ',');
  const purchasesInTransit = pulse.active_raw_purchases + pulse.active_dry_purchases;
  const overdue = overdueChambers(chambers);

  return (
    <div className="dash-statusbar">
      <div className="dash-asof">Дані оновлено станом на {stamp}</div>
      <div className="dash-pills">
        {pulse.active_dryings > 0 && (
          <span className="dash-pill is-brand">
            <span className="dash-pill-dot" />
            {pulse.active_dryings} активних сушінь
          </span>
        )}
        {purchasesInTransit > 0 && (
          <span className="dash-pill">
            <b style={{ marginRight: 5 }}>{purchasesInTransit}</b> заявки в дорозі
          </span>
        )}
        {overdue.map((c) => (
          <span key={c.id} className="dash-pill is-warning">
            {c.process_code ?? `Камера №${c.number}`} прострочене
          </span>
        ))}
      </div>
    </div>
  );
}
